<template>
    <div>
        <DataPrivacyBanner />
        <div class="content-wrapper h-100 row align-items-center">
            <div class="sections-wrapper">
                <div class="mb-2 mt-2">
                    <LocaleChanger/>
                </div>
                <div class="card">

                    <div class="section-wrapper" id="section-about-wrapper">
                        <div class="section-header">
                            <h2>{{ $t('title') }}</h2>
                            <h3>{{ $t('subtitle') }}</h3>
                        </div>

                        <div class="section-body">
                            <p style="text-align: justify">
                                {{ $t('introduction') }}
                            </p>
                            <div class="row mt-4">
                                <div class="col-12 col-md-6">
                                    <ContactForm/>
                                </div>
                                <div class="d-none d-md-block col-md-1"/>
                                <div class="col-12 col-md-5">
                                    <p style="text-align: justify">
                                        {{ $t('form.password.introduction') }}
                                    </p>
                                    <PasswordForm/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="section-wrapper alternate-section-wrapper">
                      <div class="row align-items-center">
                        <div class="col">
                        </div>
                        <div class="col-auto mt-2 mb-1">
                          <SocialIcons />
                        </div>
                      </div>
                    </div>
                </div>
              <div class="text-right">
                <Credits />
                <BackgroundChanger />
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PasswordForm from '../components/PasswordForm';
    import LocaleChanger from '../components/LocaleChanger';
    import ContactForm from '../components/ContactForm';
    import DataPrivacyBanner from '../components/DataPrivacyBanner';
    import Credits from '@/components/Credits';
    import SocialIcons from '@/components/SocialIcons';
    import BackgroundChanger from '@/components/BackgroundChanger';

    export default {
        name: "EnterPassword",
        components: {BackgroundChanger, SocialIcons, Credits, ContactForm, LocaleChanger, PasswordForm, DataPrivacyBanner}
    }
</script>

<style scoped lang="scss">

</style>
